var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer__content"},[_c('span',[_vm._v("Version "+_vm._s(_vm.version)+" / "+_vm._s(_vm.uiVersion)+" "+_vm._s(_vm.stage ? ("(" + _vm.stage + ")") : ""))])])])}
var staticRenderFns = []

export { render, staticRenderFns }